import { Container } from "@mui/material";
import React from "react";

function DashDrivers() {
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      Drivers • Work in progress
    </Container>
  );
}

export default DashDrivers;
